import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {
  PBagIcon,
  PEditIcon,
  PLinkIcon,
  PLocIcon,
  PMessIcon,
  PPhoneIcon,
  PUserE2Icon,
  PUserEIcon,
  PUserIcon,
} from "../../../../assets/icons/profileIcons";
import "./my-profile.scss";
import {Dropdown} from "antd";
import ThemeModals from "../../../components/common/modals/theme-modals/ThemeModals";
import EditProfile from "./edit-pages/EditProfile";
import EditProfessional from "./edit-pages/EditProfessional";
import {UserAuthService} from "../../../services/user-auth-api.service";
import MyProfileSkeleton from "../../skeletons/my-profile/MyProfileSkeleton";
import {useUser} from "../../../providers/UserContext";
import userIcon from "../../../../assets/images/user.png";

export default function MyProfile() {
  const [editProfile, setEditProfile] = useState(false);
  const [editProfessional, setEditProfessional] = useState(false);
  const [profileDatas, setProfileDatas] = useState(false);
  const [badgesData, setBadgesData] = useState([]);
  const [loader, setLoader] = useState(true);
  const { setProfileUpdate, profileUpdate } = useUser();

  async function GetProfileData() {
    setLoader(true);
    const response = await UserAuthService.getProfileData();

    if (response?.data?.data?.status) {
      setProfileDatas(response.data?.data?.data?.user);
      setLoader(false);
      setBadgesData(response.data?.data?.data?.user.badges);
    }
  }

  useEffect(() => {
    GetProfileData();
  }, [profileUpdate]);

  const items = [
    {
      key: "1",
      label: (
        <span
          onClick={() => {
            setEditProfile(true);
          }}
        >
          <PUserE2Icon /> Edit Profile
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <span
          onClick={() => {
            setEditProfessional(true);
          }}
        >
          <PUserEIcon /> Edit Professional Profile
        </span>
      ),
    },
  ];

  if (loader) {
    return <MyProfileSkeleton />;
  }
  const lastRank = profileDatas?.ranks?.[profileDatas?.ranks?.length - 1];

  return (
    <div className={"my-profile"}>
      <Row>
        <Col lg={12} xl={10}>
          <h2>
            My Profile
            <span>
              <Dropdown
                menu={{ items }}
                overlayClassName={"drop-2"}
                placement="bottomLeft"
                trigger={"click"}
              >
                <span className={"edit-btn"}>
                  <PEditIcon />
                </span>
              </Dropdown>
            </span>
          </h2>
        </Col>
        <Col md={12} lg={6} xl={5}>
          <div className={"my-profile-box"}>
            <div className={"profile-box-sec"}>
              <div className={"profile-box"}>
                {/*<BorderWrapper radius={'50%'}>*/}
                <div className={"profile-avatar"}>
                  <img
                    src={
                      profileDatas?.profileImage
                        ? profileDatas?.profileImage
                        : userIcon
                    }
                    className={"img-fluid"}
                  />
                </div>
                {/*</BorderWrapper>*/}
                <div className={"profile-content"}>
                  <h4>{profileDatas?.fullName}</h4>
                  {lastRank && <img src={lastRank?.after.imageUrl} />}
                </div>
              </div>
              <div className={"my-profile-box-list"}>
                <ul>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PMessIcon />
                      </div>
                      <div className={"content"}>
                        <p>Email Address</p>
                        <h5>{profileDatas?.email}</h5>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PPhoneIcon />
                      </div>
                      <div className={"content"}>
                        <p> Phone no.</p>
                        <h5>{profileDatas?.phone}</h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PLocIcon />
                      </div>
                      <div className={"content"}>
                        <p> Address</p>
                        <h5>{profileDatas?.address}</h5>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className={"my-profile-box-2"}>
                <h4>Badges</h4>

                <div className={"content"}>
                  <div className={"badges-sec"}>
                    {badgesData?.map((badge, index) => (
                      <img
                        className={"badge-img"}
                        src={badge?.after?.imageUrl}
                      />
                    ))}
                    {badgesData.length <= 0 && <p>No Badges Yet</p>}
                  </div>
                  {/*<span>See all badges</span>*/}
                </div>
              </div>
              <div className={"my-profile-box-2"}>
                <h4>Discount Code</h4>
                <div className={"content"}>
                  {!lastRank && <p>No Ranks Yet</p>}
                  {lastRank && (
                    <img
                      src={lastRank?.after?.imageUrl}
                      className={"rank-img"}
                    />
                  )}
                  {lastRank && <p>Code: {lastRank?.discountCode}</p>}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col className={"mt-3 mt-lg-0"} md={12} lg={6} xl={5}>
          <div className={"my-profile-box"}>
            <div className={"profile-box-sec"}>
              <h3>Professional Info</h3>
              <div className={"my-profile-box-list"}>
                <ul>
                  {/*<li>*/}
                  {/*  <div className={"my-profile-box-list-card"}>*/}
                  {/*    <div className={"icon"}>*/}
                  {/*      <PCapIcon />*/}
                  {/*    </div>*/}
                  {/*    <div className={"content"}>*/}
                  {/*      <p>RUK Graduated Date</p>*/}
                  {/*      <h5>*/}
                  {/*        {dayjs(profileDatas?.createdAt).format("DD-MM-YYYY")}*/}
                  {/*      </h5>*/}
                  {/*    </div>*/}
                  {/*  </div>*/}
                  {/*</li>*/}
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PUserIcon />
                      </div>
                      <div className={"content"}>
                        <p>Pod</p>
                        <h5>{profileDatas?.podNumber ? profileDatas?.podNumber : '-' }</h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PLocIcon />
                      </div>
                      <div className={"content"}>
                        <p>Business Industry</p>
                        <h5>
                          {profileDatas?.additionalFields?.businessIndustry ? profileDatas?.additionalFields?.businessIndustry : '-'}
                        </h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PBagIcon />
                      </div>
                      <div className={"content"}>
                        <p>Business Name</p>
                        <h5>{profileDatas?.additionalFields?.businessName ? profileDatas?.additionalFields?.businessName : profileDatas?.additionalFields?.businessName}</h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PLinkIcon />
                      </div>
                      <div className={"content"}>
                        <p>Business Website Link</p>
                        <h5>{profileDatas?.additionalFields?.websiteLink ? <a target={'_blank'} href={profileDatas?.additionalFields?.websiteLink}>{profileDatas?.additionalFields?.websiteLink}</a> : '-'}</h5>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {editProfile && (
        <ThemeModals
          open={editProfile}
          close={setEditProfile}
          title={"Edit Profile"}
          content={<EditProfile close={setEditProfile} />}
        />
      )}

      <ThemeModals
        open={editProfessional}
        close={setEditProfessional}
        title={"Edit Professional Profile"}
        content={<EditProfessional close={setEditProfessional} />}
      />
    </div>
  );
}
